import React, { useEffect, useState, useMemo } from "react"
import { Component } from "react"
import { Link } from "react-router-dom"
// import FixProfileNavbar from "../../Components/Navbar/FixProfileNavbar";
import "../User2/UserProfile.css"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"

import TeacherInfoHeader from "./TeacherInfoHeader"
import Moment from "react-moment";
import { connect } from "react-redux"
import { API } from "../../API";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ReactTable from "react-table-6";
import Modal from '../../Components/Modal/Modal';
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import debounce from 'lodash/debounce';
import moment from 'moment';
import { notify } from "react-notify-toast";
import { Autocomplete, TextField, Select, MenuItem } from "@mui/material";

const TeacherNote = (props) => {
	let user = JSON.parse(window.sessionStorage.getItem("admin-check-teacher")) || props.teacher;
	if (user === null) {
		window.location = "/login"
	}

	const [userNotes, setUserNotes] = useState([])
	const [loadingNote, setLoadingNote] = useState(true)
	const [college, setCollege] = useState("")
	const [attendedOnboardingDate, setAttendedOnboardingDate] = useState(moment.tz(new Date(), "Australia/Melbourne").format("DD-MM-YYYY"))
	const [coordinatorName, setCoordinatorName] = useState('Sarah')
	const [colleges, setColleges] = useState([])
	const [isShowNoteModal, setIsShowNoteModal] = useState(false)
	const [isAddingNote, setIsAddingNote] = useState(false)

	const [note, setNote] = useState({
		reason: "",
		detail: "",
		incident_date:  moment().format("DD-MM-YYYY HH:mm:ss"),
	})
	const notesColumn = useMemo(() => [
		{
			Header: "Reason",
			accessor: "reason",
			Cell: (props) => props.original.reason.toUpperCase(),
			filterable: false
		},
		{
			Header: "Note Detail",
			accessor: "detail",
			Cell: (props) => props.original.detail.slice(0, 200),
			filterable: false
		},
		{
			Header: "Created By",
			accessor: "created_by",
			width: 120,
			Cell: (props) => `${props.original.created_by.first_name} ${props.original.created_by.last_name}`,
			filterable: false
		},
		{
			Header: "Created Time",
			accessor: "created_at",
			width: 150,
			Cell: (props) => <Moment
				tz="Australia/Melbourne"
				parse="YYYY-MM-DD HH:mm:ss"
				format="DD/MM/YYYY HH:mm:ss">
				{new Date(props.original.createdAt)}
			</Moment>,
			filterable: false
		},
		{
			Header: "College",
			accessor: "college_name",
			Cell: (props) => `${props?.original?.additional_data?.college_name || ""}`,
			filterable: false,
			width: 200
		},
		{
			Header: "Coordinator",
			accessor: "coordinator_name",
			Cell: (props) => `${props?.original?.additional_data?.coordinator_name || ""}`,
			filterable: false,
			width: 100,
		},
		{
			Header: "Attended Onboarding Date",
			accessor: "attended_onboarding_date",
			Cell: (props) => <div>
				{ props?.original?.additional_data?.attended_onboarding_date ? moment(props?.original?.additional_data?.attended_onboarding_date, "DD-MM-YYYY").format('YYYY-MM-DD') : ''}
			</div>,
			filterable: false,
			width: 200
		},
	])

	const reasons = [
		{title: "Late Arrival", value: "late arrival"},
		{title: "Early Departure", value: "early departure"},
		{title: "No Show", value: "no show"},
		{title: "Negative Feedback", value: "negative feedback"},
		{title: "Positive Feedback", value: "positive feedback"},
		{title: "Employee Trial Period Ended", value: "employee trial period ended"},
		{title: "Attended Onboarding", value:"attended onboarding"},
		{title: "Late RDO", value:"late rdo"},
		{title: "Email", value:"email"},
		{title: "Call", value:"call"},
		{title: "SMS", value:"sms"},
		{title: "AMES Training - Attended onboarding", value:"ames training"},
		{title: "We tried to call you this morning", value:"missed call"},
		{title: "Please update your calendar", value:"update calendar"},
	]

	const getTeacherNotes = () => {
		API.getTeacherNotes(user._id).then((result => {
			// console.log("getTeacherNotes: ", result?.data)
			setUserNotes(result?.data?.notes || [])
			setLoadingNote(false)
		}))
	}
	const dateFromObjectId = (objectId) => {
		return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
	};
	
	const getAllColleges = async () => {
		const res = await API.allCustomers();
		const colleges = res.data
		  .sort((a, b) => {
			let dateA = dateFromObjectId(a._id);
			let dateB = dateFromObjectId(b._id);
			return dateB - dateA;
		  })
		  .map((cus) => {
			if (cus.institution_name) return cus.institution_name;
			else {
			  return cus?.institution_id?.institution_name || "";
			}
		  });
		setColleges(colleges)
	};
	useEffect(() => {
		getTeacherNotes()
		getAllColleges()
	}, [])

	const onChangeReason = (value) => {
		// console.log("value value value: ", value)
		if(value !== "employee trial period ended") {
			setCollege("")
		}
		setNote({
			...note,
			reason: value
		})
	}

	const onChangeDetail = debounce((value) => {
		setNote(preState => ({
			...preState,
			detail: value
		}))
	}, 1000);

	const setIncidentDate = (date) => {
		setNote({
			...note,
			incident_date: moment(date).format("DD-MM-YYYY HH:mm:ss")
		})
	}

	const handleAttendedOnboardingDate = (date) => {
		setAttendedOnboardingDate(moment(date).format("DD-MM-YYYY"))
	}

	const resetNote = () => {
		setNote({
			reason: "",
			detail: "",
			incident_date:  moment().format("DD-MM-YYYY HH:mm:ss"),
		})
	}

	const submitNote = () => {
		const additional_data = {}
		if(!note.reason || !note.reason.length) {
			notify.show("Please select reason", "error");
			return false
		}
		if(!note.incident_date) {
			notify.show("Please select incident date", "error");
			return false
		}
		if(note.reason === "employee trial period ended" && !college)	 {
			notify.show("Please select colleague", "error");
			return false
		} 
		if(note.reason === "employee trial period ended" && !!college) {
			additional_data.college_name = college
			// note.detail = `${college}] ${note.detail}`
		}

		if(note.reason === "attended onboarding" || note.reason === "ames training") {
			additional_data.attended_onboarding_date = attendedOnboardingDate;
			additional_data.coordinator_name = coordinatorName
		}

		setIsAddingNote(true)
		API.createTeacherNote(
			user._id,
			user.email,
			user.first_name,
			user.last_name,
			note,
			additional_data,
		  ).then((result) => {
				notify.show("Note created successfully");
				getTeacherNotes();
				// setUserNotes([
				// 	result?.data?.note,
				// 	...userNotes
				// ])
				setIsShowNoteModal(false);
				resetNote()
				setIsAddingNote(false)
		  }).catch((error) => {
				setIsAddingNote(false)
				console.log(error)
			});
	}

	return (
		<AdminWrapper>
			<SwitchMenuBar isViewAsTeacher />

			<div className="auth-right d-lg-flex bg-photoregister ">
				<div className="bg-gradient"></div>
				<div className="profile-container">
					<div className="profile-content-card-area">
						<div className="tab-content clearfix">
							<TeacherInfoHeader user={user} />
							<div className="mt-5">

								{/* navigationbar on top */}
								<div className="userNavigation d-flex justify-content-between">
									<Link
										to={{
											pathname: "/AllTeachers",
										}}
										className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
									>
										<p>BACK</p>
									</Link>
									<div className="behind-user-links">
										<Link
											to={
												{
													pathname: "/TeacherNotes"
												}
											}
											className="user-links  user-links-active d-flex user-links-background-transparent "
										>
											<p>Team Notes</p>
										</Link>
									</div>
									<div className="behind-user-links">
										<Link
											to={
												{
													pathname: "/TeacherpersonalDetails"
												}
											}
											className="user-links  d-flex user-links-background-transparent "
										>
											<p>P.Info/I.D.</p>
										</Link>
									</div>
									<div className="behind-user-links">
										<Link
											to={{
												pathname: "/TeacherBanking",
											}}
											className="user-links text-center d-flex  "
										>
											<p>Banking</p>
										</Link>
									</div>
									<div className="behind-user-links">
										<Link
											to={{
												pathname: "/validatedocuments",
											}}
											className="user-links text-center d-flex "
										>
											<p>Uploads</p>
										</Link>
									</div>
									<div className="behind-user-links">
										<Link
											to={{
												pathname: "/TeacherCalendar",
											}}
											className="user-links text-center d-flex "
										>
											<p>Calendar</p>
										</Link>
									</div>
									<div className="behind-user-links">
										<Link
											to={{
												pathname: "/TeacherJoblistAdmin",
											}}
											className="user-links text-center d-flex "
										>
											<p>JobList</p>
										</Link>
									</div>
								</div>

								{/* cpntent of the form */}
								<div className="availability-table-container">
									<div className="availability-table">
										<div className="availability-table-body mb-5">
											<div className="my-3 d-flex justify-content-end">
												<button class="btn btn-info" onClick={() => setIsShowNoteModal(true)}>
													+ New Note
												</button>
											</div>
											<div className="availability-table-body-content">
												{userNotes && <ReactTable
													className="-striped -highlight my-3"
													showPagination={false}
													data={userNotes}
													sortable={false}
													loading={loadingNote}
													pageSize={userNotes.length + 1}
													columns={notesColumn}
												/>}
											</div>
										</div>
									</div>
								</div>

								{/* navigationbar on bottom */}
								<div className="adminBottomNavigation ">
									<Link
										to={{
											pathname: "/AllTeachers",
										}}
										className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
									>
										<p>BACK - All Teachers</p>
									</Link>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<Modal
				show={isShowNoteModal}
				onClose={() => setIsShowNoteModal(false)}
				header='Add A Note'
				className='create-modal'
			>
				<p style={{ marginLeft: '-8px' }} className="my-3 font-weight-bold fs-16">Reason:</p>
				<div className="row">
					{
						reasons.map(reason => <CheckableButton
							checkbox
							id="reason"
							value={reason.value}
							className="campus-departments-checkbox mx-2"
							title={reason.title}
							key="reason"
							onChange={(e) => onChangeReason(e.target.value)}
							checked={reason.value === note.reason}
							disabled={false}
						>
							{reason.title}
						</CheckableButton>)
					}
				</div>
				{note.reason === "employee trial period ended" && (
					<Autocomplete
						options={colleges}
						size="small"
						sx={{ marginLeft: "-8px" }}
						onChange={(e, newInputValue) => setCollege(newInputValue)}
						renderInput={(params) => (
						<TextField
							sx={{ width: "285px" }}
							{...params}
							label="Select a college"
						/>
						)}
					/>
				)}
				{(note.reason === "attended onboarding" || note.reason === "ames training") && (
					<div style={{ marginLeft: '-8px' }} className="d-flex flex-row items-center justify-content-start">
						<div className="d-flex items-center">
							<label className="mb-3">Date Picker: </label>
							<FormDatePicker
								onChange={(date) => handleAttendedOnboardingDate(date)}
								value={attendedOnboardingDate}
								dateFormat="YYYY-MM-DD"
								required
								popperPlacement="right"
								className="ml-2"
							/>
						</div>
						<div className="d-flex flex-row items-center justify-content-start ml-4 mb-3">
							<label className="w-100 mb-0">Coordinator's name:</label>
							<Select
								size="small"
								labelId="demo-select-small-label"
								id="demo-select-small"
								value={coordinatorName}
								sx={{ minWidth: "200px", marginLeft: '0.5rem' }}
								onChange={(e) => setCoordinatorName(e?.target?.value)}
							>
								<MenuItem value="Sarah">Sarah</MenuItem>
								<MenuItem value="Cheata">Cheata</MenuItem>
								<MenuItem value="Ramit">Ramit</MenuItem>
								<MenuItem value="Eduardo">Eduardo</MenuItem>
								<MenuItem value="Dave">Dave</MenuItem>
							</Select>
							{/* <input className="form-control ml-2"/> */}
						</div>
					</div>
				)}

				<p style={{ marginLeft: '-8px' }} className="my-3 font-weight-bold fs-16">Detail:</p>
				<textarea
					id="detail"
					className="answer-text-field py-3 px-3"
					name="detail"
					onChange={(e) => onChangeDetail(e.target.value)}
					defaultValue=""
					autoFocus
					required={false}
					rows="200"
					style={{ marginLeft: '-8px' }}
					cols="50"
				/>

				{/* <p className="my-3 font-weight-bold fs-16"></p> */}
				<div style={{ marginLeft: '-8px' }} className="w-100 my-3 fs-16">
					<FormDatePicker
						label="Date Of Incident (Australia/Melbourne):"
						onChange={(date) => setIncidentDate(date)}
						value={note.incident_date ? note.incident_date : moment.tz(new Date(), "Australia/Melbourne").format("DD-MM-YYYY HH:mm:ss")}
						// maxDate={new Date()}
						dateFormat="YYYY-MM-DD HH:mm:ss"
						required
						showTimeSelect
						popperClassName="some-custom-class"
						timeIntervals={15}
            popperPlacement="right"
					/>
				</div>
				
				<div className='row qualification-footer mt-5'>
          <div className='col-md-6 buttons'>
            <CancelButton disabled={isAddingNote} onClick={() => setIsShowNoteModal(false)}>Cancel</CancelButton>
          </div>
          <div className='col-md-6 buttons'>
            <ConfirmButton
              onClick={() => submitNote()}
							disabled={isAddingNote}
            >
              Submit
            </ConfirmButton>
          </div>
        </div>
			</Modal>
		</AdminWrapper>
	)
}

function mapStateToProps(state) {
	return {
		teacher: state.admin.teacher,
	}
}

export default connect(mapStateToProps)(TeacherNote)
